import { useI18n } from '../i18n'
import { Banner, SupportCard } from '../components/bits'
import { useSession } from '../store/session'

export function Analysis() {
  const { t } = useI18n()
  const s = useSession()
  const a = s.analysis
  const m = s.metricsBefore
  if (!a) return null

  return (
    <section className="screen">
      <h2>{t.analysis.title}</h2>
      {s.aiFailed && <Banner text={t.errors.aiFallback} />}
      <div className="card">
        <h3>{t.analysis.readCard}</h3>
        <p>{a.analysis}</p>
      </div>
      <div className="card">
        <h3>{t.analysis.questionsCard}</h3>
        <ul>
          {a.questions.map((q, i) => (
            <li key={i}>{q}</li>
          ))}
        </ul>
      </div>
      {s.support && <SupportCard />}
      <div className="metrics">
        {m ? (
          <>
            <div className="metric"><b>{m.sharpPct}%</b><span>{t.analysis.mSharp}</span></div>
            <div className="metric"><b>{m.speedCV}</b><span>{t.analysis.mCV}</span></div>
            <div className="metric"><b>{m.strokes}</b><span>{t.analysis.mStrokes}</span></div>
            <div className="metric"><b>{m.totalSec}s</b><span>{t.analysis.mSec}</span></div>
          </>
        ) : (
          <div className="metric" style={{ gridColumn: '1/-1' }}>
            <b>{t.analysis.photoMode}</b>
            <span>{t.analysis.photoModeNote}</span>
          </div>
        )}
      </div>
      <div className="btn-row">
        <button className="btn btn-ink" onClick={() => s.go('exercise')}>
          {t.analysis.toPractice}
        </button>
      </div>
    </section>
  )
}
